import { TKeyValue } from '@interfaces/common/common';

export const generateHeaders = (headers: Array<TKeyValue>) =>
	headers?.reduce<Record<string, any>>((acc, header) => {
		acc[header.key] = header.value;

		return acc;
	}, {});
